import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {RecommendationDiscussionsService} from "../../services/recommendation-discussions.service";

@Component({
  selector: "app-discussions-button",
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./discussions-button.component.html",
})
export class DiscussionsButtonComponent {
  readonly discussions = inject(RecommendationDiscussionsService);
}
